import styled from "styled-components";

export const CardTabWrapper = styled.div<{
  $enableBorder: boolean;
}>`
  flex: 1;
  min-width: 120px;
  max-width: 270px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  align-items: center;
  justify-content: center;
  border: ${({ $enableBorder, theme }) =>
    $enableBorder ? ` 1px solid ${theme.colors.blue_d3} ` : ""};
  border-radius: 5px;
  background-color: ${({ theme }) => "white"};
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: ${({ $enableBorder }) => ($enableBorder ? "default" : "pointer")};
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;
